import { connect } from "react-redux";
import {
  ViewEntitlementModalProps as _ViewEntitlementModalProps,
  ViewEntitlementModalDataProps,
} from "./view-entitlement-modal-view";
import ViewEntitlementModal from "./view-entitlement-modal-container";
import { AppState } from "../../../store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import {
  getOrganizationEntitlement,
  listEntitlementLicenses,
  listLicenseConsumingOrgGroups,
} from "../../../actions/entActions";
import OrganizationUtils from "../../../utils/organization";
import InProgressUtils from "../../../utils/in-progress";
import { ActionSender } from "../../../model/ActionSender";
import EntitlementUtils from "../../../utils/entitlement";
import { addSenderArgument } from "../../../actions/actionHelpers";
import { clearError } from "../../../actions";
export type ViewEntitlementModalProps = Omit<
  _ViewEntitlementModalProps,
  keyof ViewEntitlementModalDataProps
>;

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _ViewEntitlementModalProps,
  ViewEntitlementModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _ViewEntitlementModalProps,
  ViewEntitlementModalProps
>;

const sender: ActionSender = { key: "view-entitlement-modal" };
/**
 * @param state
 * @param ownProps
 */
function mapStateToProps(
  state: AppState,
  ownProps: ViewEntitlementModalProps
): ReduxStateProps {
  return {
    entitlement: ownProps.entitlementId
      ? EntitlementUtils.selectEntitlement(ownProps.entitlementId, state)
      : undefined,
    entitlementGroups: ownProps.entitlementId
      ? EntitlementUtils.selectEntitlementGroups(ownProps.entitlementId, state)
      : undefined,
    entitlementLicenses: ownProps.entitlementId
      ? OrganizationUtils.selectOrganizationLicensesForEntitlement(
          ownProps.entitlementId,
          state
        )
      : undefined,
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    EntitlementUtils.compareEntitlementsStates(next, prev) &&
    EntitlementUtils.compareEntitlementGroupsStates(next, prev) &&
    OrganizationUtils.compareOrganizationLicenseStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onLoadEntitlement: addSenderArgument(sender, getOrganizationEntitlement),
  onLoadEntitlementGroups: (entId: string) =>
    listLicenseConsumingOrgGroups(sender, undefined, entId),
  onLoadEntitlementLicenses: addSenderArgument(sender, listEntitlementLicenses),
  onClearError: clearError,
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  ViewEntitlementModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(ViewEntitlementModal);
